export {
  TAB_CHILDREN,
  TAB_DEPENDENT,
  TAB_ENTITLEMENT,
  TAB_HISTORY,
  TAB_PRIVILEGE,
  TAB_SOD,
  TAB_SUMMARY,
} from '../constant';

export const MANDATORY_COLUMNS_MSG_KEY = {
  'User_LABEL.ATTESTATIONS': 'User_LABEL.ATTESTATIONS',
  'Account_LABEL.ATTESTATIONS': 'Account_LABEL.ATTESTATIONS',
  'Role_LABEL.ATTESTATIONS': 'Role_LABEL.ATTESTATIONS',
  'Ent_LABEL.ATTESTATIONS': 'Ent_LABEL.ATTESTATIONS',
  'Ent2_LABEL.ATTESTATIONS': 'Ent2_LABEL.ATTESTATIONS',
};

export const auditHistoryActionType = {
  reassigned: {
    icon: 'ReassignUser',
    iconColor: 'neutral-000',
    heading: 'Reassigned',
    date: 'Resigned On',
    user: 'Reassigned By',
    other: 'Comments',
  },
  doesNotReport: {
    icon: 'ReassignItem',
    iconColor: 'neutral-000',
    heading: 'Reassigned',
    date: 'Resigned On',
    user: 'Reassigned By',
    other: 'Comments',
  },
  consulted: {
    icon: 'Consult',
    iconColor: 'neutral-000',
    heading: 'Consulted',
    date: 'Consulted On',
    user: 'Consulted By',
    other: 'Comments',
  },
  ChangeEnddate: {
    icon: 'ExtendEndDate',
    iconColor: 'navy-700',
    heading: 'Certified',
    date: 'Certified On',
    user: 'Certified By',
    other: 'Comments',
  },
  conditionallyCertified: {
    icon: 'ExtendEndDate',
    iconColor: 'success-700',
    heading: 'Certified',
    date: 'Certified On',
    user: 'Certified By',
    other: 'Comments',
  },
  Reject: {
    icon: 'Reject',
    iconColor: 'critical-700',
    heading: 'Rejected',
    date: 'Rejected On',
    user: 'Rejected By',
    other: 'Comments',
  },
  terminated: {
    icon: 'Terminate',
    iconColor: 'critical-700',
    heading: 'Approved',
    date: 'Approved On',
    user: 'Approved By',
    other: 'Comments',
  },
  worksForMe: {
    icon: 'ConfirmManager',
    iconColor: '--color-foreground-success-medium',
    heading: 'Approved',
    date: 'Approved On',
    user: 'Approved By',
    other: 'Comments',
  },
  Approve: {
    icon: 'Check',
    iconColor: 'success-700',
    heading: 'Works For Me',
    date: 'Approved On',
    user: 'Approved By',
    other: 'Comments',
  },
  SaviCompanionSmartApprove: {
    icon: 'Check',
    iconColor: 'purple-900',
    heading: 'Approved',
    date: 'Approved On',
    user: 'Approved By',
    other: 'Comments',
  },
  SaviCompanionSmartReject: {
    icon: 'Reject',
    iconColor: 'purple-900',
    heading: 'Works For Me',
    date: 'Approved On',
    user: 'Approved By',
    other: 'Comments',
  },
  cancelled: {
    icon: 'Close',
    iconColor: 'navy-700',
    heading: 'Reset',
    date: 'Approved On',
    user: 'Approved By',
    other: 'Comments',
  },
  default: {
    icon: 'Close',
    iconColor: 'neutral-000',
    heading: 'NOT_PROVIDED',
    date: 'Approved On',
    user: 'Approved By',
    other: 'Comments',
  },
};
